import { Page } from '@react-pdf/renderer';

import { ReactNode } from 'react';

import { pageStyles } from '../styles.ts';
import { Header } from './Header.tsx';

export const Tkv2PDFPage = ({
  title,
  address,
  children,
}: {
  title: string;
  address: string;
  children: ReactNode;
}) => (
  <Page size="A4" style={pageStyles.page} wrap>
    <Header title={title} address={address} />
    {children}
  </Page>
);
